import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button"]

  toggle() {
    const showing = this.inputTarget.type === "text"
    this.inputTarget.type = showing ? "password" : "text"

    const label = showing ? this.buttonTarget.dataset.showLabel : this.buttonTarget.dataset.hideLabel
    this.buttonTarget.setAttribute("aria-label", label)
    this.buttonTarget.setAttribute("title", label)
  }
}
